<div class="container modal-body wrapper-modal position-relative">
    <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="ref.close()"></i>
    <p class="confirm_icon confirm_icon-error">
        <img src="/assets/svg/icons/icon-error-purple.svg" alt="">
    </p>
    <p *ngIf="data?.isDriverCreationEdition" class="title">Aceptación de información requerida para el documento
        {{data?.document}}</p>
    <p *ngIf="!data?.isDriverCreationEdition" class="title">¡No se han encontrado resultados para {{data?.document}}!
    </p>
    <div class="description">
        Para continuar con la creación, por favor complete los siguientes datos para solicitar la aprobación al
        conductor de:
        <ol>
            <li>Términos y Condiciones</li>
            <li>Política de Tratamiento de Datos Personales</li>
            <li *ngIf="isTeclogiUser">Contrato de Factoring Comercial</li>
            <li>Otros documentos legales que puedan ser requeridos para la manipulación, consulta y almacenamiento de
                los datos.</li>
        </ol>
        Una vez el conductor los acepte, podrás continuar con el registro.
    </div>

    <form [formGroup]="form">
        <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
            <mat-label>Nombre Completo<span class="asterisk">*</span></mat-label>
            <input matInput type="text" name="name" formControlName="name">
            <mat-error *ngIf="form.get('name')?.errors?.required">
                {{ utils.giveMessageError('MISSING_FIELD', 'nombre') }}
            </mat-error>
            <mat-error *ngIf="form.get('name')?.errors?.pattern">
                {{ utils.giveMessageError('INCORRECT_FORMAT', 'nombre') }}
            </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
            <mat-label>Celular / WhatsApp<span class="asterisk">*</span></mat-label>
            <input matInput type="tel" name="phone" formControlName="phone">
            <mat-error *ngIf="form.get('phone')?.errors?.required">
                {{ utils.giveMessageError('MISSING_FIELD', 'celular') }}
            </mat-error>
            <mat-error *ngIf="form.get('phone')?.errors?.pattern">
                {{ utils.giveMessageError('INCORRECT_FORMAT', 'celular') }}
            </mat-error>
            <mat-error *ngIf="form.get('phone')?.errors?.duplicatedPhone">
                El número de celular ya está asociado a alguien
            </mat-error>
        </mat-form-field>
        <p class="my-2 text-bold">
            Seleccione el canal por el cual desea enviar la solicitud:
        </p>
        <div class="d-flex flex-wrap justify-content-around">
            <div class="button-terms-and-conditions" (click)="copyDriverRegistration()"
                matTooltip="Permite copiar la dirección del enlace al portapapeles para compartirlo fácilmente al conductor"
                matTooltipClass="tooltip__alert">
                <i class="far fa-copy fa-lg"></i>
                <p class="d-none d-sm-block">Copiar enlace</p>
            </div>
            <div class="button-terms-and-conditions" (click)="onSubmit()"
                matTooltip="Permite enviar un mensaje de texto al número del conductor para el registro"
                matTooltipClass="tooltip__alert" [ngClass]="{'disabled': form.invalid || form.untouched}">
                <i class="fas fa-sms fa-lg"></i>
                <p class="d-none d-sm-block">Mensaje de texto</p>
            </div>
            <div class="button-terms-and-conditions" (click)="sendMessageToWhatsapp()"
                matTooltip="Permite enviar un mensaje directo al whatsapp del conductor con el enlace para el registro"
                matTooltipClass="tooltip__alert" [ngClass]="{'disabled': form.invalid || form.untouched}">
                <i class="fab fa-whatsapp fa-lg"></i>
                <p class="d-none d-sm-block">WhatsApp</p>
            </div>
        </div>
    </form>
</div>